.cardLink {
    display: block;
    width: 100%;
    cursor: pointer;
    border-radius: var(--mantine-radius-md);
    text-decoration: none;
    color: inherit;
}

.cardLink:focus-visible {
    outline: 2px solid var(--mt-brand-accent);
    outline-offset: 2px;
}

.card {
    transition:
        box-shadow 150ms ease,
        border-color 150ms ease,
        background-color 150ms ease;
}

.cardLink:hover .card,
.cardLink:focus-visible .card {
    background-color: var(--mt-brand-subtle);
    border-color: var(--mt-brand-border);
    box-shadow: var(--mantine-shadow-sm);
}

.cardLink:active .card {
    box-shadow: none;
}
